import React, { useEffect, useState } from 'react'
import '../../styles/common/professional-loader.scss'

const PageTransition = ({ children, isLoading = false }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(true)
  }, [])

  return (
    <>
      {isLoading && (
        <div className="page-transition-loader">
          <div className="progress-bar"></div>
        </div>
      )}
      <div className={`page-transition-wrapper ${show ? 'fade-enter-active' : 'fade-enter'}`}>
        {children}
      </div>
    </>
  )
}

export default PageTransition
